import React from "react";

function SpecialRequestPage() {
  return <div>SpecialRequestPage</div>;
}

export default SpecialRequestPage;
